import React from 'react';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import parse from 'html-react-parser';
import cx from 'classnames';

import IKImage from '../IKImage/IKImage';
import { BREAKPOINTS_VALUES } from '../../theme';
import useStyles from './styles';

const ContactDetailsBlock = ({ data: blockData }) => {
  const background = blockData?.background;
  // const heading = blockData?.heading;
  const items = blockData?.items;
  const classes = useStyles(background)();

  return (
    <Box
      className={cx(
        classes.wrapper,
        background === 'Dark' ? 'dark-block' : 'light-block',
        'contact-details-block',
      )}
    >
      <Container className={classes.container}>
        <Box className={classes.detailsBox}>
          {items?.map((item) => {
            const heading = item?.heading;
            const icon = item?.icon_url;
            const content = item?.editable_html;

            return (
              <Box key={heading} className={cx(classes.detailBox, 'details-block')}>
                <Box className={classes.detailBoxImage}>
                  <IKImage
                    path={icon}
                    alt={heading}
                    draggable={false}
                    srcset={[{ width: 50 }, { width: 72 }]}
                    sizes={`(max-width:${BREAKPOINTS_VALUES['sm']}px) 50px, 72px`}
                  />
                </Box>
                <Box className={classes.detailBoxContent}>
                  <Typography
                    variant="h4"
                    component="h4"
                    align="left"
                    className={cx(classes.detailBoxTitle, 'details-title')}
                  >
                    {heading}
                  </Typography>
                  <Box className={classes.detailBoxDescription}>{parse(content)}</Box>
                </Box>
              </Box>
            );
          })}
        </Box>
      </Container>
    </Box>
  );
};

export default ContactDetailsBlock;
